import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import classnames from 'classnames';

import ToastComponent from '../Components/common/Toast';
import messageService from '../Services/message';
import userService from '../Services/user';

const Settings = () =>{
    const [toastMessage, setToastMessage] = useState(false);
    const [users, setUsers] = useState([]);
    const [updateFlag, setUpdateFlag] = useState(false);

    const history = useHistory();
    const goback = () => history.push('/main')

    const deleteMessages = async()=>{
        const res = await messageService.deleteAllMessages();
        if(res.success) setToastMessage(`Deleted Data  [ Messages: ${res.message.n} Files: ${res.files.length} ]`);
        else setToastMessage(res.err);
    }

    const externalRefresh = (action, message) =>{
        if(action) setUpdateFlag(!updateFlag);
        setToastMessage(message);
    }

    useEffect(()=>{
        const fetchData = async() =>{
            const res = await userService.getUsers();
            if(res.success) setUsers(res.users)
            else setToastMessage(res.error);
        }

        fetchData();
    },[updateFlag])

    return(
        <Container fluid className ='p-0 m-0 d-flex flex-column position-relative shadow-lg'>
            <div className='d-flex justify-content-center settings'>
                <div 
                    className='material-icons position-absolute p-2 rounded-circle shadow-lg pointer bg-dark text-white'
                    style={{top:10, right:20, zIndex: 5}}
                    onClick={goback}
                >keyboard_arrow_left</div>
                <Card className='align-self-center' style={{height: '90%', width:'90%'}} >
                    <Card.Header>REGISTER USERS</Card.Header>
                    <Card.Body className='d-flex flex-column p-2 px-3 font12'>
                        <Row className='align-items-center font-weight-bold flex-shrink-0 shadow-sm py-1'>
                            <Col sm={3}>NAME</Col>
                            <Col sm={3}>EMAIL</Col>
                            <Col sm={2}>LAST LOGIN</Col>
                            <Col xs={9} sm={2}>ROL</Col>
                            <Col xs={3} sm={2}>ACTIONS</Col>
                        </Row>
                        <div className='overflow-auto w-100' style={{fontSize: 12}}>
                            {
                                users?.sort().map((u,i)=>(
                                    <UserElement user={u} key={i} externalRefresh={externalRefresh}/>
                                ))
                            }
                        </div>
                    </Card.Body>
                    <Card.Footer>
                        Users: {users.length}
                    </Card.Footer>
                </Card>
            </div>
            
            <div className='px-3 py-2 d-flex justify-content-between align-items-center flex-shrink-0'>
                <Button variant='danger' className='font-weight-bold' size='sm' onClick={deleteMessages}>DELETE MESSAGES FROM DB</Button>
                <i className='text-muted float-right font12'>e1maxSystems {new Date().getFullYear() }</i>
            </div>
            <ToastComponent message={toastMessage} close={setToastMessage} className='position-absolute toastMessage' />
        </Container>
    )
}

const UserElement = props =>{
    const {avatar, email, name, rolX, lastLogin, _id, enabled} = props.user;

    const updateEnabledStatus = async(id, dataEnabled)=>{
        const res = await userService.updateUserEnabled(id, dataEnabled);
        if(res.success){
           props.externalRefresh(true, res.message)
        }
        else props.externalRefresh(false, res.err);
    }

    const deleteUser = async(email) =>{
        const res = await userService.deleteUser(email);
        if(res.success) props.externalRefresh(true, res.message);
        else props.externalRefresh(false, res.err);
    }
    
    return(
        <Row className={classnames('border py-2 px-0 align-items-center ', {'text-muted': !enabled })}>
            <Col sm={3} className='d-flex align-items-center'><img src={require(`./../avatars/${avatar ?? 0}.png`).default } height ='40'className='rounded-circle pr-2' alt={`User`}/>{name}</Col>
            <Col sm={3}>{email}</Col>
            <Col sm={2}>{lastLogin ? moment(lastLogin).fromNow(): 'null'}</Col>
            <Col xs={9}sm={2}>{rolX ? 'admin' : 'standard'}</Col>
            <Col xs={3}sm={2} className='justify-content-end'>
                    <i 
                        className={classnames('material-icons pr-2 pointer', {'text-success': enabled}, {'text-danger': !enabled})}
                        onClick={()=>updateEnabledStatus(_id, !enabled)}
                        >{enabled ? 'check' : 'block' }
                    </i>
                    <i className='material-icons text-danger pointer' onClick={()=>deleteUser(email)}>cancel</i>
            </Col>
        </Row>
    )
}

export default Settings;